export default {
      id: "weather__thermometer-usage",
      viewBox: "0 0 64 64",
      url: __webpack_public_path__ + "img/icons.svg#weather__thermometer",
      toString: function () {
        return this.url;
      }
    }